import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { STRINGS } from "../Strings";
import { FiArrowRight } from "react-icons/fi";

// Picha inaitwa hapa kwenye JSX pekee kwa ajili ya Parallax Background
import bgMembershipParallax from '../assets/orphans.jpg';

export default function HomeMembership(props) {
    const appContext = useContext(AppContext);
    const language = appContext.language || "sw";
    const s = STRINGS.homeMembership;

    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Space for initialization if needed
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <div 
                className="MainBodySection membership-parallax-canvas position-relative d-flex align-items-center justify-content-center"
                style={{ backgroundImage: `url(${bgMembershipParallax})` }}
            >
                {/* Custom Mixed Dark Blue-Green Overlay with lower opacity */}
                <div className="membership-mixed-overlay"></div>

                {/* Centered Content Container */}
                <div className="container position-relative z-index-3 text-center text-white vip-content-box">
                    <span className="membership-kicker text-uppercase font-semi-bold mb-3 d-inline-block">
                        {s.topTag[language]}
                    </span>
                    
                    <h2 className="title-font-bold membership-main-heading mb-4 mx-auto">
                        {s.heading[language]}
                    </h2>
                    
                    <p className="font-regular membership-lead-paragraph mb-5 mx-auto">
                        {s.description[language]}
                    </p>

                    {/* Simple Premium Button: Border Outline Only */}
                    <button 
                        className="btn btn-membership-outline title-font-semi-bold d-inline-flex align-items-center gap-2"
                        onClick={() => appContext.navTo({ item: 'membership' })}
                    >
                        <span>{s.buttonText[language]}</span>
                        <FiArrowRight size={16} className="arrow-tr" />
                    </button>
                </div>
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "550px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}